<div class="animated fadeInRight">
    <!-- MENU DE TITULOS -->
    <app-lfsa-card-v2
      [titulo]      = "'Impresión de documentos relacionados'"
      [modulo]      = "GLOBAL_TITULOS.modulo"
      [tituloCard]  = "DAT_TITULOS.tituloCardList"
      [innTemplate] = "enviarTemplateEdit"
      [innTemplateButton]="innTemplateButton">
    </app-lfsa-card-v2>
    <!-- MENU DE TITULOS -->

    <!-- OPCIONES BOTONES IZQUIERDO -->
    <ng-template #innTemplateButton>
      <div class="col-md-6 mb-2">
        <div class="pagetitle">
          <div class="btn-group-justified btn-group" style="float: right;">
            <button type="button" class="btn btn-outline-primary" [disabled]="descargandoZip" (click)="descargarReportesInspeccionZip()">
              ZIP reportes
              <span *ngIf="progresoZip">({{ progresoZip }})</span>
            </button>
          </div>
        </div>
      </div>
    </ng-template>
    <!-- OPCIONES BOTONES IZQUIERDO -->

    <!-- GRILLA -->
    <ng-template #enviarTemplateEdit>
        <div class="card mb-2">
            <div class="card-header">
                <strong>Filtros de búsqueda</strong>
            </div>
            <div class="card-body">
                <form [formGroup]="formFiltro">
                    <div class="row">
                        <div class="form-group col-md-3">
                            <label>Fecha inicio</label>
                            <input type="date" class="form-control" formControlName="fechaInicio">
                        </div>
                        <div class="form-group col-md-3">
                            <label>Fecha fin</label>
                            <input type="date" class="form-control" formControlName="fechaFin">
                        </div>
                        <div class="form-group col-md-3">
                            <app-lfsa-combo-box
                                [comboBox]="listCentros"
                                [control]="formFiltro.get('centroDestino')"
                                [idOpcion]="'idCentro'"
                                [opcion]="'nombreCentro'"
                                [id]="'centroDestino'"
                                [label]="'Centro destino'"
                                formControlName="centroDestino">
                            </app-lfsa-combo-box>
                        </div>
                        <div class="form-group col-md-3">
                            <app-lfsa-combo-box
                                [comboBox]="cmbTiposPlanificacion"
                                [control]="formFiltro.get('tipo')"
                                [idOpcion]="'idTipo'"
                                [opcion]="'nombre'"
                                [id]="'tipo'"
                                [label]="'Tipo'"
                                formControlName="tipo">
                            </app-lfsa-combo-box>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-3">
                            <label>Proveedor ID</label>
                            <div class="input-group">
                                <input type="text" class="form-control" formControlName="proveedorId" (change)="getProveedor()">
                                <div class="input-group-append">
                                    <app-busqueda-proveedor (onSelect)="proveedorSeleccionado($event)"></app-busqueda-proveedor>
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-md-6">
                            <label>Nombre del proveedor</label>
                            <input type="text" class="form-control" [(ngModel)]="proveedorNombreFiltro" [ngModelOptions]="{standalone: true}" readonly>
                        </div>
                        <div class="col-md-3" style="padding-top: 25px;">
                            <button type="button" class="btn btn-primary w-60" (click)="buscar()">Buscar</button>
                            <button type="button" class="btn btn-secondary w-30" (click)="limpiarFiltros()">Limpiar</button>
                            <button type="button" class="btn btn-success w-30" (click)="downloadDataCsv()">Exportar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <!-- <div class="form-group col-md-12">
            <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter " (keyup)="onQuickFilterChanged() " #quickFilter />
        </div> -->
        <br>
        <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
        <div class="row">
            <div class="col">
                <ag-grid-angular #agGrid (gridReady)="onGridReady($event)"
                                    [id]    ="DAT_AG_GRID.id"
                                    [class] ="DAT_AG_GRID.class"
                                    [ngStyle]="DAT_AG_GRID.style"
                                    [rowData]="rowData"
                                    [rowSelection] = 'rowSelection'
                                    [columnDefs]="columnDefs"
                                    [rowHeight]="DAT_AG_GRID.rowHeight"
                                    [pagination]="DAT_AG_GRID.pagination"
                                    [paginationPageSize]="DAT_AG_GRID.pagina"
                                    [allowContextMenuWithControlKey]="true"
                                    [frameworkComponents]="frameworkComponents" >
                </ag-grid-angular>
            </div>
        </div>

    </ng-template>
    <!-- GRILLA -->
  </div>

